/**
 * Currency-aware rate formatting for timesheet displays.
 *
 * Uses the platform-native Intl.NumberFormat with the pay rate's ISO-4217
 * currency code, so the symbol comes from the record (£, ¥, $, …) instead of a
 * hardcoded literal. Falls back to USD when the currency is absent (legacy or
 * un-threaded data), preserving the historical "$" behavior.
 */

const DEFAULT_CURRENCY = "USD";

/**
 * Format an hourly pay rate with its currency symbol, e.g. "£150.00/hr".
 * Zero-decimal currencies (JPY) render without cents, e.g. "¥150/hr".
 * Returns an empty string for a non-finite rate so callers can omit the rate
 * fragment entirely rather than rendering a confident "$0.00/hr".
 *
 * @param {number} rate - the hourly rate
 * @param {string} [currency] - ISO-4217 currency code (defaults to USD)
 * @returns {string}
 */
export const formatHourlyRate = (rate, currency) => {
  if (!Number.isFinite(rate)) return "";

  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || DEFAULT_CURRENCY,
  }).format(rate);
  return `${formatted}/hr`;
};
